import React, { FC } from 'react';
import { RouterProvider } from 'react-router-dom';
import { routeConfig } from './RouteConfig';

const Router: FC = () => {
  return <RouterProvider router={routeConfig} />;
};

export default Router;
